module.exports = __webpack_public_path__ + "img/ic-cancel.5e2fb354.svg";